import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-create-1',
  imports: [],
  templateUrl: './create-1.component.html',
  styleUrl: './create-1.component.css',
})
export class Create1Component {
  @Output() stepChange = new EventEmitter<number>();

  handleNext(){
    this.stepChange.emit(2);
  }
}
